/**
 * App specific color tokens that don't belong in the global product theme.
 */
export const white = '#ffffff';
